import { GroupAddOutlinedIcon, useTheme } from 'opensolar-ui'
import React from 'react'
import { useHistory } from 'react-router-dom'
import SupplierIntegrationPricingLabel from './SupplierIntegrationPricingLabel'

const IndicativePriceLabel: React.FC = () => {
  const history = useHistory()
  const theme = useTheme()

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    history.push('/shop/cart')
  }

  return (
    <SupplierIntegrationPricingLabel
      labelText="Est. Price"
      labelStyle={theme.typography.body3 as React.CSSProperties}
      icon={<GroupAddOutlinedIcon size={14} />}
      tooltipImageUrl={`${window.PUBLIC_URL}/images/indicative-pricing-tooltip.svg`}
      tooltipImageAlt="Indicative pricing"
      tooltipHeading="Get your special trade price"
      tooltipBody="Connect with your Account Manager on Supplier Assist for your final price. Access it via Shop or your Cart."
      tooltipLinkText="Take me there"
      onLinkClick={handleLinkClick}
    />
  )
}

export default IndicativePriceLabel
